import { Component, Input, OnInit } from '@angular/core';
import { ILayoutSettings, IPageContent } from '@app/feature/store-editor/components/layout/store-editor.interface';
import { CommonService } from '@app/feature/store-editor/services/common.service';

@Component({
  selector: 'app-cta-setting',
  templateUrl: './cta-setting.component.html',
  styleUrls: ['../styling/styling.component.css']
})
export class CTASettingComponent implements OnInit {

  @Input() item: IPageContent;

  @Input() layoutSetting: ILayoutSettings;
  constructor(private cs: CommonService) {
  }

  ngOnInit() {
    this.item.data = this.cs.setDefaultSetting(this.item.data);
  }


  RemoveLink(index: number) {
    this.item.data.Buttonlink.splice(index, 1);
  }

  AddLink() {
    this.item.data.Buttonlink.push({
      link: "#Link",
      text: "Text on Button",
      colorLink: ""
    });
  }

  SelectButtonStyle(style: string, index: number) {
    this.item.data.Buttonlink[index].colorLink = style;
  }
}
